<template>
    <div id="all">
      <div class="header">
        <van-icon @click="$emit('closeTheScreen')" class="icon" size="30" color='rgba(255,255,255,0.6)' name="arrow-left" />
        <div>学者库</div>
        <img @click="$emit('closeTheScreen')" src="@/assets/img/details/sx.png" alt="">
      </div>
      <div class="choiceArea">
        <div class="left">
          <ul>
            <li :class="{pitchLeft: oneHighlight == item.id}" @click="One(item.id)" v-for="item in researchDirection" :key="item.id" class="pitch">{{item.subjectName}}</li>
          </ul>
        </div>
        <div :class="{vanLoading:status == null}" class="right">
          <ul v-if="status !== null">
            <li :class="{pitchRight:towHighlight == itemTow.id}" @click="Two(itemTow.id)" v-for="itemTow in otherList" :key="itemTow.id">
              <div class="omit">{{itemTow.subjectName}}</div>
              <van-icon v-if="towHighlight == itemTow.id" class="icon" name="success" />
            </li>
          </ul>
          <van-loading v-if="status == null" size="24px">加载中...</van-loading>
        </div>
      </div>
      <div class="but">
        <div @click="reset" class="reset">重置</div>
        <div class="interval"></div>
        <div @click="confirm" class="confirm">确定</div>
      </div>
    </div>
</template>

<script>
import { Loading, Icon } from 'vant'
export default {
     name:'Filtrate',
    components: {
      'van-loading':Loading,
      'van-icon':Icon
    },
    props: {

    },
    data() {
        return {
          researchDirection:[], // 一级列表
          otherList:[], //二级列表
          oneHighlight: sessionStorage.getItem('Filtrate') ? JSON.parse(sessionStorage.getItem('Filtrate')).levelOne : 1 , // 一级高亮 (默认第一个)
          towHighlight: sessionStorage.getItem('Filtrate') ? JSON.parse(sessionStorage.getItem('Filtrate')).levelTwo : null , // 二级高亮/及检索数据
          status:null
        };
    },
    computed: {

    },
    watch: {
    },
    async created() {
     await this.getOneList()
     await this.getTwoList(this.oneHighlight)
    },
    mounted() {

    },
    methods: {
      // 拉取研究方向一级列表
      async getOneList() {
        const resp = await this.$apis.hundredServe.getOneList();
        this.researchDirection = resp.researchOneList
      },
      // 拉取研究方向二级列表
      async getTwoList(id) {
        const resp = await this.$apis.hundredServe.getTwoList({
          prevSubjectId: id,
        });
        this.otherList = []
        this.otherList.push(...resp.researchTwoList) 
        this.status = 1
      },
      // 一级列表选择
      One(id) {
        this.towHighlight = null
        this.oneHighlight = id
        this.status = null
        this.getTwoList(id)
      },
      // 二级列表选择
      Two(id) {
        this.towHighlight = id
      },
      // 确定
      confirm() {
        // 存储选择的筛选参数
        if(this.oneHighlight && this.towHighlight) {
          let obj = {
            levelOne:this.oneHighlight,
            levelTwo:this.towHighlight
          }
          sessionStorage.setItem('Filtrate',JSON.stringify(obj))
        }
        this.$router.push({
          path:'/academiclibraries',
          query:{
            levelOne:this.oneHighlight,
            levelTwo:this.towHighlight
          }
        })
      },
      // 重置
      reset() {
        this.oneHighlight = 1
        this.towHighlight = null
        sessionStorage.removeItem('Filtrate')
      }
    },
    beforeDestroy() {
      // 重置
      this.oneHighlight = 1
      this.towHighlight = null
    }
};
</script>

<style scoped lang="scss">
#all{
  & .header{
    width: 100%;
    height: 131px;
    background-image: linear-gradient(#433AC7, #1C72F3);
    display: flex;
    justify-content:space-between;
    position: fixed;
    top: 0;
    z-index: 9;
    & .icon{
      line-height: 131px;
      margin-left: 20px;
    }
    & div{
      line-height: 131px;
      font-size: 18px;
      color: #fff;
      position: relative;
      right: 10px;
    }
    & img{
      position: relative;
      top: 54px;
      width: 25px;
      height: 25px;
      right: 20px;
    }
  }
  & .choiceArea{
  width: 100%;
  height: 100%;
  position: fixed;
  background: #fff;
  top: 90px;
  left: 0;
  z-index: 999;
  font-size: 15px;
  display: flex;
    & .left{
      width: 50%;
      height: 100%;
      background: rgba(228, 235, 255, 25%);
      padding: 20px 10px 100px 20px;
      & ul{
        height: 90%;
        overflow: auto;
        font-weight: 600;
        color: #000;
        padding-top: 17px;
        & li{
          width: 100%;
          margin-bottom: 35px;
          // line-height: 15px;
          padding-left: 10px;
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1; 
          -webkit-box-orient: vertical;
        }
      }
    }
    & .right{
      width: 50%;
      height: 100%;
      background: rgba(255, 255, 255, 1);
      padding: 20px 0px 100px 0px;
      & ul{
        height: 90%;
        overflow: auto;
        color: #303030;
        & li{
          width: 100%;
          height: 40px;
          padding-left: 20px;
          line-height: 40px;
          font-size: 14px;
          margin-top: 5px;
          padding-right: 40px;
          & .omit{
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1; 
            -webkit-box-orient: vertical;
          }
          & .icon{
            color: #2453d2;
            position: relative;
            top: -32px;
            left: 22px;
            float: right;
            font-size: 22px;
          }
        }
      }
    }
  }
  & .but{
    width: 100%;
    height: 50px;
    background: rgb(255, 255, 255);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.096);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    text-align: center;
    line-height: 50px;
    & .reset{
      width: 50%;
      height: 100%;
      color: rgba(153, 153, 153, 1);
    }
    & .interval{
      width: 2px;
      height: 30px;
      background: rgba(210, 210, 210, 1);
      position: relative;
      top: 10px;
    }
    & .confirm{
      width: 50%;
      height: 100%;
      color: rgba(40, 93, 255, 1);

    }
  }

}
.pitchLeft{
  border-left: 5px solid rgba(36, 83, 210, 1);
}
.pitchRight{
  color: rgba(36, 83, 210, 1);
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.178);
  border-top: 1px solid rgba(0, 0, 0, 0.075);
  border-radius: 10px;
  margin-bottom: 5px;
}
#all::-webkit-scrollbar {
    display: none;
}
.vanLoading {
      position: relative;
      top: 0;
      bottom: 0;
      left: 20px;
      right: 0;
      width: 50% !important;
      height: 30% !important;
      margin:auto;
}
</style>
